import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";

export const CameraDropDownSMTP = ({
  showUserDropDown,
  navBarCollapsed,
}: {
  showUserDropDown: boolean;
  navBarCollapsed: boolean;
}) => {
  const navigate = useNavigate();

  const {
    cameraOptionsSMTP,
    siteOptionsSMTP,
    cameraDropDownValueSMTP,
    setCameraDropDownValueSMTP,
    setUserFiltersSMTP,
    loadingCamerasSMTP,
    getDownloadURLSMTP,
  } = useClipsStore();

  const cameraIds = new Map();
  (cameraOptionsSMTP || []).forEach((object: any) => {
    cameraIds.set(object.camera_name, object.id);
  });

  const siteIds = new Map();
  (siteOptionsSMTP || []).forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  // Create a Set to track unique camera names and ensure we only add each name once
  const uniqueCameraNames = new Set<string>();
  const options: string[] = [];

  // First pass: collect unique camera names
  (cameraOptionsSMTP || []).forEach((object: any) => {
    if (!uniqueCameraNames.has(object.camera_name)) {
      uniqueCameraNames.add(object.camera_name);
      options.push(object.camera_name);
    }
  });

  let sx: any;

  if (showUserDropDown && navBarCollapsed) {
    sx = { width: 175 };
  }

  if (showUserDropDown && !navBarCollapsed) {
    sx = { width: 150 };
  }

  if (!showUserDropDown && navBarCollapsed) {
    sx = { width: 235 };
  }

  if (!showUserDropDown && !navBarCollapsed) {
    sx = { width: 200 };
  }
  return (
    <div key="camera_dropdown_smtp">
      <Autocomplete
        value={cameraDropDownValueSMTP}
        disablePortal
        options={options}
        loading={loadingCamerasSMTP}
        onChange={(event, value: any) => {
          if (value !== null) {
            setCameraDropDownValueSMTP(value);
            setUserFiltersSMTP((previousState: any) => {
              return { ...previousState, camera_ids: [cameraIds.get(value)] };
            });
          } else {
            setCameraDropDownValueSMTP(value);
            setUserFiltersSMTP((previousState: any) => {
              return { ...previousState, camera_ids: [] };
            });
          }
          getDownloadURLSMTP(navigate);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Camera"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCamerasSMTP ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={sx}
          />
        )}
      />
    </div>
  );
};
